export default "__VITE_ASSET__MimtOKPa__"